import React from "react";

const MultiUser = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
	<svg
		width={size}
		style={style}
		height={size}
		viewBox={viewBox}
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={`${className || ""}`}
		xmlnsXlink="http://www.w3.org/1999/xlink"
	>
		<path className="u_fill"
			d="M8.064 31.182c0-2.645 1.042-5.182 2.896-7.053a9.846 9.846 0 016.992-2.921 9.846 9.846 0 016.993 2.921 10.018 10.018 0 012.896 7.053H8.064zm9.889-11.22c-4.098 0-7.417-3.349-7.417-7.482 0-4.132 3.319-7.48 7.417-7.48 4.097 0 7.416 3.348 7.416 7.48 0 4.133-3.32 7.481-7.416 7.481zm9.1 2.783c1.891.49 3.58 1.57 4.828 3.084A9.402 9.402 0 0134 31.182h-3.687c0-3.254-1.236-6.216-3.26-8.437zm-2.5-2.838a9.946 9.946 0 002.43-3.359c.567-1.28.86-2.666.858-4.067a9.996 9.996 0 00-1.255-4.867 6.171 6.171 0 013.564 2.163 6.267 6.267 0 011.399 3.95c0 .889-.188 1.767-.551 2.576a6.23 6.23 0 01-1.557 2.115 6.13 6.13 0 01-4.888 1.49z"
			  fill={fill}
		/>
		<path className="u_fill"
			d="M8.947 22.745a9.268 9.268 0 00-4.828 3.084A9.402 9.402 0 002 31.182h3.687c0-3.254 1.236-6.216 3.26-8.437zm2.5-2.838a9.946 9.946 0 01-2.43-3.359 10.022 10.022 0 01-.858-4.067 9.997 9.997 0 011.255-4.867A6.171 6.171 0 005.85 9.777a6.278 6.278 0 00-.847 6.526c.363.809.894 1.53 1.556 2.115a6.164 6.164 0 002.284 1.278c.843.257 1.731.329 2.604.211z"
			  fill={fill}
		/>
	</svg>
);

export default MultiUser;
